import PropTypes from 'prop-types';
import { memo, Fragment } from 'react';
import { Text } from '@gasbuddy/react-components';
import formatDiscount from '../../../lib/utils/formatDiscount';

function PayRowTooltipContent({ isPayUser, seesDeal }) {
  const discount = formatDiscount(null, 25);

  if (seesDeal) {
    return (
      <Fragment>
        <Text as="p">
          The prices in this row are the prices you pay when you activate the Deal Alert below.
        </Text>
        <Text as="p">
          Keep an eye out for Deal Alerts and you could save {discount} per gallon -
          including your base discount if you are a Pay with GasBuddy member.
        </Text>
      </Fragment>
    );
  }

  if (isPayUser) {
    return (
      <Fragment>
        <Text as="p">
          The prices in this row are the prices you get as a Pay with GasBuddy member!
        </Text>
        <Text as="p">
          Keep an eye out for Deal Alerts and you could save {discount} per gallon - including your base discount.
        </Text>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <Text as="p">
        The prices in this row are the prices that you could be paying with our Pay with GasBuddy card.
      </Text>
      <Text as="p">
        Join Pay with GasBuddy today to save {discount} per gallon on every fill-up.
      </Text>
    </Fragment>
  );
}

PayRowTooltipContent.propTypes = {
  isPayUser: PropTypes.bool,
  seesDeal: PropTypes.bool,
};

PayRowTooltipContent.defaultProps = {
  isPayUser: false,
  seesDeal: false,
};

export default memo(PayRowTooltipContent);
